"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.getAuthInnerState = exports.AuthProvider = exports.useAuthDispatch = exports.useAuthSelector = exports.useAuthProviderSelector = exports.AuthAction = exports.useAuthContext = void 0;
const jsx_runtime_1 = require("react/jsx-runtime");
const react_1 = require("react");
const authProvider_reducer_1 = require("./authProvider.reducer");
const authProvider_types_1 = require("./authProvider.types");
const AuthContext = (0, react_1.createContext)({
    get: () => authProvider_types_1.AuthProviderStateInit,
    dispatch: () => undefined,
    subscribe: () => () => undefined
});
const useAuthContext = () => (0, react_1.useContext)(AuthContext);
exports.useAuthContext = useAuthContext;
exports.AuthAction = authProvider_reducer_1.authReducerActions;
const useAuthProviderSelector = (selector) => {
    const value = (0, exports.useAuthContext)();
    const state = (0, react_1.useSyncExternalStore)(value.subscribe, () => selector(value.get()));
    return {
        state,
        dispatch: value.dispatch
    };
};
exports.useAuthProviderSelector = useAuthProviderSelector;
const useAuthSelector = (selector) => {
    const { state } = (0, exports.useAuthProviderSelector)(selector);
    return state;
};
exports.useAuthSelector = useAuthSelector;
const useAuthDispatch = () => {
    const { dispatch } = (0, exports.useAuthContext)();
    return dispatch;
};
exports.useAuthDispatch = useAuthDispatch;
let _authInnerState = authProvider_types_1.AuthProviderStateInit;
const useRefReducer = (...[reducer, initState]) => {
    const ref = (0, react_1.useRef)(initState);
    const dispatch = (0, react_1.useCallback)((action) => {
        ref.current = reducer(ref.current, action);
    }, []);
    return { stateRef: ref, dispatch };
};
const useAuthProvider = () => {
    const subscribers = (0, react_1.useRef)(new Set());
    // @ts-ignore
    const { stateRef, dispatch } = useRefReducer(authProvider_reducer_1.authProviderReducer, authProvider_types_1.AuthProviderStateInit);
    const handleDispatch = (0, react_1.useCallback)((action) => {
        dispatch(action);
        subscribers.current.forEach(sub => sub());
        _authInnerState = stateRef.current;
    }, []);
    const get = (0, react_1.useCallback)(() => stateRef.current, []);
    const subscribe = (0, react_1.useCallback)((callback) => {
        subscribers.current.add(callback);
        return () => subscribers.current.delete(callback);
    }, []);
    return {
        get,
        dispatch: handleDispatch,
        subscribe
    };
};
const AuthProvider = ({ children }) => {
    const value = useAuthProvider();
    return ((0, jsx_runtime_1.jsx)(AuthContext.Provider, { value: value, children: children }));
};
exports.AuthProvider = AuthProvider;
const getAuthInnerState = () => _authInnerState;
exports.getAuthInnerState = getAuthInnerState;
